import React from 'react';
import { AlertTriangle } from 'lucide-react';

// A reusable layout for auth pages
export const AuthLayout = ({ title, children }) => (
  <div className="flex items-center justify-center min-h-screen bg-gray-100">
    <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-md">
      <h2 className="text-3xl font-bold text-center text-gray-900">{title}</h2>
      {children}
    </div>
  </div>
);

// Reusable Input component
export const FormInput = ({ id, label, type, value, onChange, error }) => (
  <div>
    <label htmlFor={id} className="block text-sm font-medium text-gray-700">
      {label}
    </label>
    <input
      id={id}
      name={id}
      type={type}
      required
      value={value}
      onChange={onChange}
      className={`w-full px-3 py-2 mt-1 border rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 ${
        error ? 'border-red-500' : 'border-gray-300'
      }`}
    />
    {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
  </div>
);

/*export const FormButton = ({ children, isLoading }) => (
  <button
    type="submit"
    disabled={isLoading}
    className="w-full px-4 py-2 font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
  >
    {isLoading ? 'Zpracovávám...' : children}
  </button>
);*/
export const FormButton = ({ children, isLoading, disabled, ...props }) => {
  return (
    <button
      disabled={disabled || isLoading}
      
      className={`
        w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white transition-colors duration-200
        ${
          disabled || isLoading
            ? 'bg-gray-400 cursor-not-allowed' // STYLES WHEN DISABLED (Grey + No Cursor)
            : 'bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500' // STYLES WHEN ACTIVE
        }
      `}
      {...props}
    >
      {isLoading ? (
        // SHOW THIS WHEN LOADING
        <>
          <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Zpracovávám... 
        </>
      ) : (
        // SHOW THIS NORMALLY (e.g., "Registrovat")
        children
      )}
    </button>
  );
};

export const FormError = ({ message }) => {
  if (!message) return null;
  return (
    <div className="flex items-center p-3 text-sm text-red-700 bg-red-100 rounded-md border border-red-200">
      <AlertTriangle className="w-5 h-5 mr-2 flex-shrink-0" />
      <span className="flex-grow">{message}</span>
    </div>
  );
};

export const getQueryParam = (param) => {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) === param) {
      return decodeURIComponent(pair[1]);
    }
  }
  return null;
};